/* eslint-disable */
import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export interface LeaveTypeSummaryItem {
  month: string;
  annual: number;
  casual: number;
  medical: number;
  others: number;
}

export type LeaveTypeSummaryResponse = {
  success: boolean;
  data: LeaveTypeSummaryItem[];
  message?: string;
};

const fetchLeaveTypeSummary = async (
  year: number,
  department?: string | number,
  employee?: string | number
): Promise<LeaveTypeSummaryResponse> => {
  const params = new URLSearchParams();
  params.append("year", String(year));
  if (
    department !== undefined &&
    department !== null &&
    String(department) !== ""
  )
    params.append("department", String(department));
  if (employee !== undefined && employee !== null && String(employee) !== "")
    params.append("employee", String(employee));

  const url = `/reports/leaves/leaveTypeSummary?${params.toString()}`;
  return (await customAxios.get<LeaveTypeSummaryResponse>(url)).data;
};

export const useGetLeaveTypeSummary = (
  year: number,
  department?: string | number,
  employee?: string | number
) =>
  useQuery<LeaveTypeSummaryResponse, AxiosError>(
    ["leaveTypeSummary", year, department, employee],
    () => fetchLeaveTypeSummary(year, department, employee),
    {
      onError: (error) =>
        showNotification({
          title: "Error Loading Leave Type Summary",
          message:
            (error.response?.data as { message?: string })?.message ??
            "Failed to load leave type summary",
          color: "red",
        }),
      enabled: !!year,
      staleTime: 0,
      retry: 1,
      refetchOnMount: "always",
    }
  );
